import classNames from "classnames";
import * as React from "react";
import { VideoOverlay } from "../../components/VideoOverlay";
import "./ProgramSchedule.scss";

interface IProgramExpanderProps {
  type: string;
  presenter: string;
  date: string;
  time: string;
}

export const ProgramExpander: React.FunctionComponent<IProgramExpanderProps> = (
  props
) => {
  const [expanded, setExpanded] = React.useState(false);
  return (
    <div className={classNames("ProgramExpander", { expanded })}>
      <div className="HeaderBar" onClick={() => setExpanded(!expanded)}>
        <span>{props.type}: </span>
        <span className="Presenter">{props.presenter}</span>
        <span className="Splitter Pipe"> | </span>
        <span className="Date">{props.date}</span>
        <span className="Splitter"> / </span>
        <span className="Time">{props.time}</span>
        <div className={classNames("Expander", { expanded })} />
      </div>
      <div className={classNames("Body", { expanded })}>{props.children}</div>
    </div>
  );
};

interface IProgramScheduleProps {}

export const ProgramSchedule: React.FunctionComponent<IProgramScheduleProps> = (
  props
) => {
  const [video, setVideo] = React.useState("");

  return (
    <div
      className={classNames("ProgramSchedule", {
        showingVideo: Boolean(video),
      })}
    >
      <h2>
        CES<sup>®</sup> 2022 Virtual Program Schedule
      </h2>
      <div className="Expanders">
        <ProgramExpander
          type="CES Panel"
          presenter="Frontiers in Business AI"
          date="Wednesday, January 5, 2022"
          time="9:00–9:40AM PST"
        >
          <div>
            <strong>Date:</strong> Wednesday, January 5, 2022
          </div>
          <div>
            <strong>Time:</strong> 9:00–9:40 a.m. PST
          </div>
          <div>
            <strong>Activity:</strong> CES Panel
          </div>
          <div>
            <strong>Title:</strong> Frontiers in Business AI
          </div>
          <div>
            <strong>Session Overview:</strong> Meet some trailblazing companies
            and innovators who are taking big leaps with AI and get a glimpse
            into the impact it will have on our lives.
          </div>
          <div>
            <strong>Speaker:</strong> Jahmy Hindman
          </div>
          <div>
            <strong>Location:</strong> LVCC, North Level 2, N251
          </div>
        </ProgramExpander>
        <ProgramExpander
          type="CES Panel"
          presenter="The Long Road to Fully Autonomous Driving"
          date="Wednesday, January 5, 2022"
          time="3:00–3:30PM PST"
        >
          <div>
            <strong>Date:</strong> Wednesday, January 5, 2022
          </div>
          <div>
            <strong>Time:</strong> 3:00–3:30 p.m. PST
          </div>
          <div>
            <strong>Activity:</strong> CES Panel
          </div>
          <div>
            <strong>Title:</strong> The Long Road to Fully Autonomous Driving
          </div>
          <div>
            <strong>Session Overview:</strong> Hear from leaders in the
            autonomous technology industry about what it will take to see fully
            autonomous vehicles on the road – and in the field.
          </div>
          <div>
            <strong>Speaker:</strong> Aubrey Donnellan
          </div>
          <div>
            <strong>Location:</strong> WIRED.com
          </div>
        </ProgramExpander>
        <ProgramExpander
          type="Tireside Chat"
          presenter="Driving (Autonomously) with Purpose"
          date="Wednesday, January 5, 2022"
          time="3:30–3:45PM PST"
        >
          <div>
            <strong>Date:</strong> Wednesday, January 5, 2022
          </div>
          <div>
            <strong>Time:</strong> 3:30–3:45 p.m. PST
          </div>
          <div>
            <strong>Activity:</strong> Tireside Chat
          </div>
          <div>
            <strong>Title:</strong> Driving (Autonomously) With Purpose
          </div>
          <div>
            <strong>Session Overview:</strong> Discover why farmers need
            autonomy today — and why autonomy is ready for the farm now.
          </div>
          <div>
            <strong>Speakers:</strong> Deanna Kovar and Igino Cafiero
          </div>
          <div>
            <strong>Location:</strong> John Deere Booth (LVCC, Central Plaza –
            CP–14)
          </div>
        </ProgramExpander>
        <ProgramExpander
          type="CES Panel"
          presenter="Seizing the Opportunity of Tech Innovation With 5G"
          date="Thursday, January 6, 2022"
          time="10:20–11:20AM PST"
        >
          <div>
            <strong>Date:</strong> Thursday, January 6, 2022
          </div>
          <div>
            <strong>Time:</strong> 10:20–11:20 a.m. PST
          </div>
          <div>
            <strong>Activity:</strong> CES Panel
          </div>
          <div>
            <strong>Title:</strong> Seizing the Opportunity of Tech Innovation
            With 5G
          </div>
          <div>
            <strong>Session Overview:</strong> Learn about how 5G is unlocking
            opportunities for innovation across industries, including
            agriculture and manufacturing.
          </div>
          <div>
            <strong>Speaker:</strong> Deanna Kovar
          </div>
          <div>
            <strong>Location:</strong> LVCC, North Hall, Room N262
          </div>
        </ProgramExpander>
        <ProgramExpander
          type="Tireside Chat"
          presenter="This isn’t Old Macdonald’s Farm"
          date="Thursday, January 6, 2022"
          time="11:00–11:15AM PST"
        >
          <div>
            <strong>Date:</strong> Thursday, January 6, 2022
          </div>
          <div>
            <strong>Time:</strong> 11:00–11:15 p.m. PST
          </div>
          <div>
            <strong>Activity:</strong> Tireside Chat
          </div>
          <div>
            <strong>Title:</strong> This Isn’t Old MacDonald’s Farm
          </div>
          <div>
            <strong>Session Overview:</strong> Learn about the technology
            farmers rely on to do their jobs — and how tech impacts both their
            operation and their lives.
          </div>
          <div>
            <strong>Speakers:</strong> Jahmy Hindman and Taylor Nelson
          </div>
          <div>
            <strong>Location:</strong> John Deere Booth (LVCC, Central Plaza –
            CP–14)
          </div>
        </ProgramExpander>
        <ProgramExpander
          type="Tireside Chat"
          presenter="Swipe to Begin Farming"
          date="Thursday, January 6, 2022"
          time="3:00–3:15PM PST"
        >
          <div>
            <strong>Date:</strong> Thursday, January 6, 2022
          </div>
          <div>
            <strong>Time:</strong> 3:00–3:15 p.m. PST
          </div>
          <div>
            <strong>Activity:</strong> Tireside Chat
          </div>
          <div>
            <strong>Title:</strong> Swipe to Begin Farming
          </div>
          <div>
            <strong>Session Overview:</strong> Hear about the technologies like
            machine learning that make autonomy possible and how it works.
          </div>
          <div>
            <strong>Speakers:</strong> Julian Sanchez and Willy Pell
          </div>
          <div>
            <strong>Location:</strong> John Deere Booth (LVCC, Central Plaza –
            CP–14)
          </div>
        </ProgramExpander>
      </div>
      {video && (
        <VideoOverlay
          src={video}
          show={Boolean(video)}
          onOverlayClicked={() => setVideo("")}
        />
      )}
    </div>
  );
};
